import { Avatar, Box, IconButton } from "@mui/material"
import { DamsColors } from "../styles/DamsColors";
import { DamsAppAsset } from "../../assets/registry";
import RemoveIcon from '@mui/icons-material/Remove';
function TableCheckBox({
    isChecked,
    setIsChecked,
    onClick,
    isHeader = false,
    hasItemsSelected=false,
}:
    Readonly<{
        isChecked?: boolean,
        setIsChecked?: (value: boolean) => void,
        onClick?: () => void
        isHeader?:boolean
        hasItemsSelected?: boolean
    }>) {

    return (
        <IconButton
            onClick={() => {
                onClick && onClick();
            }}
        >

            <Box
                height={20}
                width={20}
                borderRadius={1}
                border={`2px solid ${!isChecked ?
                    DamsColors.Border.InputOuterBorder :
                    DamsColors.Background.RoundCircleActive}`}
                display={'flex'}
                alignItems={'center'}
                justifyContent={'center'}
                bgcolor={!isHeader && isChecked ? DamsColors.Badge.Green.background : hasItemsSelected && isHeader ? DamsColors.Badge.Grey.background:''}
            >
                { !isHeader  && isChecked  && (
                    <Avatar
                        src={DamsAppAsset.icons.green_check}
                        sx={styles.checkIcon}
                        variant="square" />
                )}

                {hasItemsSelected && isHeader   &&
                <RemoveIcon fontSize="small" />}
            </Box>
        </IconButton>
    )
}



const styles = {
    checkIcon: {
        width: '14px',
        height: '14px',
    },


}

export { TableCheckBox }
